import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

@Injectable({
    providedIn: 'root'
})
export class ContractIncidentService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cm/contractIncidents')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-triangle-exclamation';
    }

    getObjectLabels(): string[] {
        return ['incidentDate', 'dunningLevel', 'totalDunningAmount'];
    }

}
